<template>
  <form>
    <v-container class="main-container responsive-height">
      <v-row>
        <v-col xl="6" lg="7" md="7" sm="7" cols="12">
          <v-card class="deposit-form" :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Transfer Method</legend>
                  <v-text-field label="Bank Transfer" disabled placeholder="Bank Transfer" single-line solo hide-details
                    readonly class="custom-select"></v-text-field>
                </fieldset>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Deposit to</legend>
                  <v-select v-model="selectedAccount" :items="formattedAccounts" item-text="display"
                    item-value="trading_account_no" solo append-icon="mdi-chevron-down" label="Select One"
                    class="custom-select" hide-details @change="handleAccountChange"></v-select>
                </fieldset>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <fieldset>
                  <legend>Bank Name</legend>
                  <v-select v-model="selectedBank" :items="banks" item-text="beneficiary_bank_name" item-value="id" solo
                    append-icon="mdi-chevron-down" label="Select One" class="custom-select" hide-details
                    @change="handleBankChange"></v-select>
                </fieldset>
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <fieldset>
                  <legend>Bank Account Number</legend>
                  <v-text-field v-model="bankAccountNumber" :value="selectedBankAccount" label="Bank Account Number"
                    single-line solo hide-details readonly class="custom-select"></v-text-field>
                </fieldset>
              </v-col>
              <v-col cols="12" sm="12" md="6" v-if="bankIbanNum != 'N/A'" :md="ifscCode != 'N/A' ? 6 : 12">
                <fieldset>
                  <legend>Beneficiary IBAN</legend>
                  <v-text-field v-model="bankIbanNum" label="Beneficiary IBAN" single-line solo hide-details readonly
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>
              <v-col cols="12" sm="12" v-if="ifscCode != 'N/A'" :md="bankIbanNum != 'N/A' ? 6 : 12">
                <fieldset>
                  <legend>IFSC Code</legend>
                  <v-text-field v-model="ifscCode" label="IFSC Code" single-line solo hide-details readonly
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>
              <v-col cols="12" sm="12" md="6" :md="currency.name !== 'USD' ? 6 : 12">
                <fieldset>
                  <legend>Amount in (USD)</legend>
                  <v-text-field min="1" v-model="depositAmount" label="$" type="number" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>
              <v-col cols="12" sm="12" md="6" v-if="currency.name !== 'USD'">
                <fieldset>
                  <legend>Amount in <span :style="{ color: currency.color }">({{ currency.name }})</span></legend>
                  <v-text-field readonly v-model="currencyAmount" :label="currency.symbol" type="number" single-line solo hide-details
                    class="custom-select text-muted"></v-text-field>
                </fieldset>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <fieldset>
                  <legend>Transaction ID</legend>
                  <v-text-field v-model="transactionId" label="Transaction ID" single-line solo hide-details
                    class="custom-select"></v-text-field>
                </fieldset>
              </v-col>
              <v-col cols="12" sm="12" md="12" v-if="needSlip == 1">
                <div class="input-file">
                  <span>Upload Bank Slip</span>
                  <v-file-input v-model="bankSlip" label="Choose file" filled prepend-icon="mdi-file-image"
                    hide-details></v-file-input>
                </div>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-btn type="submit"  @click.prevent="handleSubmit" tile elevation="0" class="ma-0 text-capitalize btn-account d-block"
                  color="greenMain" :loading="loading" :disabled="loading">
                  Deposit
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col xl="4" lg="4" md="5" sm="5" cols="12">
          <v-card v-if="selectedAccountDetails" class="elevation-0 rounded-0 deposit-form-card mt-2"
            :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
            <v-card-actions>
              <div class="trade-status">
                <div>
                  <v-icon color="greenMain">mdi-signal</v-icon>
                </div>
                <div class="trade-number">
                  <span>MT5 - {{ selectedAccountDetails.account_type_display }}</span>
                  <span>{{ selectedAccountDetails.trading_account_no }}</span>
                </div>
              </div>
            </v-card-actions>
            <v-card-actions>
              <div class="value-trades">
                <span>Balance</span>
                <span>{{ selectedAccountDetails.Balance }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="value-trades">
                <span>Currency</span>
                <span>{{ selectedAccountDetails.currency_name }}</span>
              </div>
            </v-card-actions>
            <v-card-actions>
              <v-sheet :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
                <div>
                  <apexChart width="100%" height="95px" type="line" :options="options" :series="series" />
                </div>
              </v-sheet>
            </v-card-actions>
            <v-card-actions>
              <div class="currency-leverage">
                <span>Free Funds</span>
                <span>{{ selectedAccountDetails.MarginFree }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="currency-leverage">
                <span>Leverage</span>
                <span>{{ selectedAccountDetails.leverage }}:1</span>
              </div>
            </v-card-actions>
            <v-card-actions>
              <div class="balance-equity">
                <span>Free Margin</span>
                <span>{{ selectedAccountDetails.MarginFree }}</span>
              </div>
              <v-spacer></v-spacer>
              <div class="balance-equity">
                <span>Acc. Type</span>
                <span>{{ selectedAccountDetails.account_type_display }}</span>
              </div>
            </v-card-actions>
          </v-card>

          <v-card v-if="selectedAccountDetails?.is_trade_master == 1" class="elevation-0 rounded-0 deposit-form-card mt-2 mb-5" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
            <v-card-actions>
              <div class="value-trades">
                <p>Investment Rule</p>
              </div>
            </v-card-actions>
            <v-card-actions>
                <span class="rules-info">
                  <p class="color-white">1.First Deposit:</p>
                  <li>The first deposit must be $1,000 plus an annual fee of $110.</li>
                  <li>Total First Deposit = $1,110</li>
                </span>
            </v-card-actions>
             
            <v-card-actions>
                <span class="rules-info mt-3">
                  <p class="color-white">2.Subsequent Deposits:</p>
                  <li>Any additional deposit must be a multiple of $500.</li>
                  <li>Allowed amounts: $500, $1,000, $1,500, $2,000, etc.</li>
                  <li>Not allowed: $600, $750, $1,250, etc.</li>
                </span>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { DEPOSITMETHODS__ACTIONS } from "@/store/action-types";
import toast from "@/services/Notification";
import account from "@/store/profile/account";

export default {
  data() {
    return {
      payment_id: null,
      selectedAccount: null,
      selectedBank: null,
      bankAccountNumber: '',
      bankIbanNum: '',
      ifscCode: '',
      depositAmount: '',
      currencyAmount: '',
      transactionId: '',
      bankSlip: null,
      loading: false,
      currency: {
        rate: 1,
        name: "USD",
        symbol: "$",
        color:"#fff"
      },
      options: {
        chart: {
          type: "line",
          toolbar: { show: false },
        },
        xaxis: {
          labels: { show: false },
          axisTicks: { show: false },
          axisBorder: { show: false },
        },
        yaxis: { labels: { show: false } },
        grid: { show: false },
        stroke: { width: 2 },
        dataLabels: { enabled: false },
        colors: ["#3A648E"],
      },
      series: [
        {
          name: "Series 1",
          data: [45, 52, 38, 45, 19, 23, 2],
        },
      ],
    };
  },

  computed: {
    ...mapState("deposit", ["methods", "accounts", "banks","needSlip"]),
    formattedAccounts() {
      return this.accounts.map(account => ({
        display: `${account.trading_account_no} (${account.account_type_display}) ${account.Balance} ${account.currency_name}`,
        trading_account_no: account.trading_account_no,
        ...account
      }));
    },
    selectedAccountDetails() {
      return this.accounts.find(acc => acc.trading_account_no === this.selectedAccount);
    },
    selectedBankAccount() {
      if (this.selectedBank) {
        const bank = this.banks.find(b => b.id === this.selectedBank);
        return bank ? bank.beneficiary_account : '';
      }
      return '';
    }
  },

  watch: {
    depositAmount(newAmount) {
      if (this.currency && this.currency.rate) {
        this.currencyAmount = (newAmount * this.currency.rate).toFixed(2);
      } else {
        this.currencyAmount = newAmount;
      }
    }
  },

  methods: {
    ...mapActions("deposit", [
      DEPOSITMETHODS__ACTIONS.DEPOSITACCOUNTS,
      DEPOSITMETHODS__ACTIONS.DEPOSITMETHODS,
      DEPOSITMETHODS__ACTIONS.BROKERSBANK,
      DEPOSITMETHODS__ACTIONS.CREATEBANKDEPOSIT,
      DEPOSITMETHODS__ACTIONS.NEEDSLIP,
    ]),
    handleMethodChange() {
      this.selectedBank = null;
      this.bankAccountNumber = '';
      this.bankSlip = null;
    },

    handleAccountChange() {
      let account_details = this.accounts.find(acc => acc.trading_account_no === this.selectedAccount);
      
      this.depositAmount = '';
      this.currencyAmount = '';

      if (account_details) {
        this.currency.rate = account_details.currency_rate;
        this.currency.name = account_details.currency_name;
        this.currency.symbol = account_details.currency_symbol;
        this.currency.color = account_details.symbol_color;
      }
    },


    handleBankChange() {
      const selectedBankDetails = this.banks.find(b => b.id === this.selectedBank);

      if (selectedBankDetails) {
        this.bankAccountNumber = selectedBankDetails.beneficiary_account;
        this.bankIbanNum = selectedBankDetails.beneficiary_IBAN;
        this.ifscCode = selectedBankDetails.ifsc_code;
      } else {
        this.bankAccountNumber = '';
        this.bankIbanNum = '';
        this.ifscCode = '';
      }
    },

    async handleSubmit() {
      try {
        this.loading = true;
        const amount = parseFloat(this.depositAmount);
        if (isNaN(amount) || amount <= 0) {
          this.loading = false;
          return toast.error('Please enter a valid deposit amount');
        }

        const formData = new FormData();
        formData.append('trading_account_no', this.selectedAccount);
        formData.append('amount', this.depositAmount);
        formData.append('transaction_id', this.transactionId);
        formData.append('payment_slip', this.bankSlip);
        formData.append('bank_id', this.selectedBank);
        formData.append('bank_account_no', this.bankAccountNumber);
        formData.append('payment_id', this.payment_id);

        await this[DEPOSITMETHODS__ACTIONS.CREATEBANKDEPOSIT](formData);
      } catch (error) {
        console.error('Deposit submission error:', error.message);
      } finally {
        this.loading = false;
        this.resetForm();
      }
    },


    resetForm() {
      this.selectedAccount = null;
      this.selectedBank = null;
      this.bankAccountNumber = '';
      this.depositAmount = '';
      this.transactionId = '';
      this.bankSlip = null;
    }
  },
  async created() {
    this.payment_id = this.$route.query.payment_id;
    await this[DEPOSITMETHODS__ACTIONS.DEPOSITMETHODS]();
    await this[DEPOSITMETHODS__ACTIONS.DEPOSITACCOUNTS]();
    await this[DEPOSITMETHODS__ACTIONS.BROKERSBANK]();
    await this[DEPOSITMETHODS__ACTIONS.NEEDSLIP]();
  },
};
</script>

<style>
  .text-muted{
    opacity: .7;
  }
</style>
